import React, { createContext, useState } from 'react'

export const TpaContext =  createContext()

function TpaContextProvider({children}) {
  const [tpaState, setTpaState] = useState({
    medicalType : "",
    medicalTests : [],
    tpaName : "",
    matchType : "",
    skipPage : false,
  })

  const [tpaStateSA, setTpaStateSA] = useState({
    medicalType : "",
    medicalTests : [],
    tpaName : "",
    matchType : "",
    skipPage : false,
    isSA : null,
  })

  return (
    <TpaContext.Provider value={{tpaState,setTpaState,tpaStateSA,setTpaStateSA}}>
        {children}
    </TpaContext.Provider>
  )
}

export default TpaContextProvider